import { useState } from "react"
import { coreRequest } from "services/requests"
import storage from "utils/persistentStorage"
import { LOCAL_STORAGE_PREFIX } from "common/constants"

const prefix = "dictionary"
const sendRequest = coreRequest.sendRequest

const useApi = () => {
  const [isFetching, setIsFetching] = useState(false)

  const getLanguages = async () => {
    const cacheKey = `${LOCAL_STORAGE_PREFIX}global_languages_${process.env.REACT_APP_VERSION}`
    const cachedData = await storage.getItem(cacheKey)
    if (cachedData) return cachedData

    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/languages`,
      body: null,
      method: "get",
    })
    if (response.success) {
      const data = response.data?.languages || []
      await storage.setItem(cacheKey, data)
      setIsFetching(false)
      return data
    }

    if (!response.success) console.log(response.message)
    setIsFetching(false)
    return []
  }

  const getTranslation = async ({ id }) => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/languages/${id}/dictionary/JSON`,
      body: null,
      method: "get",
    })
    if (!response.success) console.log(response.message)
    setIsFetching(false)
    return response.data
  }

  const getTranslationByCode = async ({ code }) => {
    setIsFetching(true)
    const data = await getLanguages()
    const language = data.find((lang) => lang.code === code)
    if (!language) return {}
    const response = await getTranslation({ id: language.languageId })
    setIsFetching(false)
    return response
  }

  return {
    getLanguages,
    getTranslation,
    getTranslationByCode,
    isFetching,
  }
}

export default useApi
